// besturimz-website/src/components/AboutContact.js
import React from 'react'
import styled from 'styled-components'
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaHandshake, FaAward, FaUsers } from 'react-icons/fa'
import { PHONE_NUMBERS, CONTACT_EMAIL } from '../constants/contact'

const COMPANY_ADDRESS =
  'Akdeniz Mahallesi GMK Blv. Erdoğan Center No:910/20 Kat:7, Mezitli / Mersin'

// Gerçek konuma yakın nokta: https://maps.app.goo.gl/bZY3q1H179yx8h8n6
const MAP_LAT = 36.7337519
const MAP_LNG = 34.5144668
const MAP_EMBED_URL = `https://maps.google.com/maps?q=${MAP_LAT},${MAP_LNG}&z=17&output=embed`
const MAP_LINK = 'https://maps.app.goo.gl/bZY3q1H179yx8h8n6'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 2rem;
  align-items: stretch;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 2.25rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`

const AboutCard = styled(Card)`
  background: linear-gradient(160deg, #ffffff 0%, #f8fafc 100%);
`

const Lead = styled.p`
  font-size: 1.1rem;
  line-height: 1.75;
  color: #334155;
  margin: 0 0 1.25rem;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`

const Body = styled.p`
  font-size: 0.98rem;
  line-height: 1.7;
  color: #64748b;
  margin: 0 0 1.75rem;
`

const Highlights = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: auto;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const Highlight = styled.div`
  text-align: center;
  padding: 1rem 0.75rem;
  border-radius: 12px;
  background: #f8f9fa;
  border: 1px solid #eef2f7;
`

const HighlightIcon = styled.div`
  width: 44px;
  height: 44px;
  margin: 0 auto 0.65rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #c62828 0%, #1565c0 100%);
  font-size: 1.1rem;
`

const HighlightTitle = styled.div`
  font-size: 0.92rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.25rem;
`

const HighlightText = styled.div`
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.4;
`

const CardTitle = styled.h3`
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 1.25rem;
`

const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  margin-bottom: 1.25rem;
`

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.9rem;
`

const ContactIcon = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 1rem;
`

const ContactText = styled.div`
  font-size: 0.95rem;
  color: #334155;
  line-height: 1.55;

  a {
    color: #1565c0;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

const ContactLabel = styled.div`
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 0.2rem;
`

const MapWrap = styled.div`
  margin-top: auto;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  min-height: 220px;
  height: 240px;
  background: #f1f5f9;
`

const MapFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
`

const AboutContact = () => {
  return (
    <Wrapper>
      <AboutCard>
        <CardTitle>Hakkımızda</CardTitle>
        <Lead>
          BESTURİZM olarak 20 yılı aşkın deneyimimizle uçak bileti, otobüs bileti ve
          konaklama hizmetlerinde güvenilir çözümler sunuyoruz.
        </Lead>
        <Body>
          Amacımız, seyahat planlarınızı hızlı, şeffaf ve konforlu hale getirmek.
          Yurt içi ve yurt dışı uçuşlardan şehirlerarası otobüs biletlerine, otel
          rezervasyonlarından özel konaklama taleplerine kadar tüm süreçte yanınızdayız.
          Müşteri memnuniyetini esas alan hizmet anlayışımızla her adımda size destek oluyoruz.
        </Body>
        <Highlights>
          <Highlight>
            <HighlightIcon>
              <FaAward />
            </HighlightIcon>
            <HighlightTitle>20+ Yıl</HighlightTitle>
            <HighlightText>Sektör deneyimi</HighlightText>
          </Highlight>
          <Highlight>
            <HighlightIcon>
              <FaUsers />
            </HighlightIcon>
            <HighlightTitle>Müşteri Odaklı</HighlightTitle>
            <HighlightText>Kişisel destek</HighlightText>
          </Highlight>
          <Highlight>
            <HighlightIcon>
              <FaHandshake />
            </HighlightIcon>
            <HighlightTitle>Güvenilir Ağ</HighlightTitle>
            <HighlightText>Güçlü iş ortakları</HighlightText>
          </Highlight>
        </Highlights>
      </AboutCard>

      <Card>
        <CardTitle>İletişim Bilgileri</CardTitle>
        <ContactList>
          <ContactItem>
            <ContactIcon>
              <FaMapMarkerAlt />
            </ContactIcon>
            <ContactText>
              <ContactLabel>Adres</ContactLabel>
              <a href={MAP_LINK} target="_blank" rel="noopener noreferrer">
                {COMPANY_ADDRESS}
              </a>
            </ContactText>
          </ContactItem>
          <ContactItem>
            <ContactIcon>
              <FaPhone />
            </ContactIcon>
            <ContactText>
              <ContactLabel>Telefon</ContactLabel>
              {PHONE_NUMBERS.map((phone, index) => (
                <span key={phone.tel}>
                  {index > 0 && <br />}
                  <a href={`tel:${phone.tel}`}>{phone.display}</a>
                </span>
              ))}
            </ContactText>
          </ContactItem>
          <ContactItem>
            <ContactIcon>
              <FaEnvelope />
            </ContactIcon>
            <ContactText>
              <ContactLabel>E-posta</ContactLabel>
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </ContactText>
          </ContactItem>
        </ContactList>

        <MapWrap>
          <MapFrame
            title="Besturizm Konum"
            src={MAP_EMBED_URL}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </MapWrap>
      </Card>
    </Wrapper>
  )
}

export default AboutContact
